let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lUh9w")).then(() => parcelRequire('5F6io'));